module.exports = __webpack_public_path__ + "static/media/Stationery-Mockup-Shaadi Bazaar.afbce455.jpg";